import script from "./PolicyReviewCriteriaItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./PolicyReviewCriteriaItem.vue?vue&type=script&setup=true&lang=ts"

import "./PolicyReviewCriteriaItem.vue?vue&type=style&index=0&id=757ef8e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-757ef8e8"]])

export default __exports__